import { useEffect, useState } from "react";
import { Truck } from "lucide-react";
import api from "../lib/api";
import { COUNTRIES } from "../lib/countries";

export function ShippingFields({ product, qty, setQty, country, setCountry, onQuote }) {
  const [quote, setQuote] = useState(null);
  const maxQty = Math.min(product.max_qty || 10, product.stock ?? 100);

  useEffect(() => {
    if (!country) { setQuote(null); onQuote?.(null); return; }
    api.get("/shipping/quote", { params: { product_id: product.id, country, quantity: qty } })
      .then((r) => { setQuote(r.data); onQuote?.(r.data); })
      .catch(() => { setQuote(null); onQuote?.(null); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, qty, product.id]);

  return (
    <div className="mt-6 grid sm:grid-cols-2 gap-4" data-testid="shipping-fields">
      <div>
        <label className="overline text-[#4a4a4a]">Quantity</label>
        <select data-testid="qty-select" value={qty} onChange={(e) => setQty(parseInt(e.target.value, 10))} className="mt-2 w-full border border-[#e5e5e5] bg-white px-4 py-3 outline-none focus:border-[#0a192f]">
          {Array.from({ length: Math.max(1, maxQty) }, (_, i) => i + 1).map((n) => <option key={n} value={n}>{n}</option>)}
        </select>
      </div>
      <div>
        <label className="overline text-[#4a4a4a]">Ship to country</label>
        <select data-testid="country-select" value={country} onChange={(e) => setCountry(e.target.value)} className="mt-2 w-full border border-[#e5e5e5] bg-white px-4 py-3 outline-none focus:border-[#0a192f]">
          <option value="">Select country…</option>
          {COUNTRIES.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
        </select>
      </div>
      <div className="sm:col-span-2 text-sm text-[#1a1a1a] bg-[#fdfbf7] border border-[#e5e5e5] px-4 py-3 flex items-center gap-3" data-testid="shipping-quote">
        <Truck className="w-4 h-4 text-[#d4af37] flex-shrink-0" />
        {quote ? (
          <span>{quote.shipping_cents === 0 ? "Free shipping" : `Shipping $${(quote.shipping_cents / 100).toFixed(2)}`} · {quote.domestic ? "Standard" : "International"} · ships in {quote.handling_days}. Sales tax is calculated at checkout from your address.</span>
        ) : (
          <span>Choose your country to see the shipping cost. Sales tax is calculated at checkout.</span>
        )}
      </div>
    </div>
  );
}
